import '../../app.es6';
import angular from 'angular';
import reductio from '../../../node_modules/reductio/reductio.min.js';
import h337 from '../../../node_modules/heatmap.js/heatmap.js';

const COMPONENT_NAME = 'tennisGraph';
const HEAT_MAP_WIDTH = 420;
const HEAT_MAP_HEIGHT = 426;

class TennisGraph {
  /* @ngInject */
  constructor (
    $scope, $rootScope, $element, $q, $http, $parse, $sessionStorage,
    SwingTypeConstants, ImpactPointConstants, sssSharedState, SharedState, Const
  ) {
    // TODO : 削除予定
    this.Const = Const;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$parse = $parse;
    this.swingTypes = SwingTypeConstants;
    this.impactPoints = ImpactPointConstants;
    this.sharedState = sssSharedState;
    this.UiSharedState = SharedState;
    this.datetimeFormatter = d3.time.format('%Y/%m/%d %X');
    this.valueFormatter = d3.format('.1f');
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_SHOT_KIND] = this.Const.SHOT_TYPE.all;

    let shot = this.shot = this.chartinfo.shot;
    this.shotdate = shot.dimension((d) => d.date);
    this.chartinfo.reportCtrl.setTennisChartCtrl(this);

    // for average value update in spin/swingspeed/ballspeed graph
    this.spin = reductio().avg((d) => d.impact.spin)(shot.groupAll());

    this.ballSpeed = reductio().avg((d) => d.impact.speed)(shot.groupAll());

    this.swingSpeed = reductio().avg((d) => d.swing.speed)(shot.groupAll());

    let userSeries = {};
    userSeries.dim = shot.dimension((d) => d.minute);
    userSeries.gp = userSeries.dim.group();

    let userSeriesRangeBar = {};
    userSeriesRangeBar.dim = shot.dimension((d) => d.minute);
    userSeriesRangeBar.gp = userSeriesRangeBar.dim.group();

    let swingType = {};
    swingType.dim = shot.dimension((d) => d.swing_type);
    swingType.gp = this.buildSwingTypeGroup(swingType.dim.group());

    let impactPoint = {};
    impactPoint.dim = shot.dimension((d) => d.impact.spot);
    impactPoint.gp = impactPoint.dim.group();

    let spin = {};
    spin.dim = shot.dimension((d) => d.second);
    spin.gp = this.reducer(spin.dim.group(), (v) => v.impact.spin);

    let swingSpeed = {};
    swingSpeed.dim = shot.dimension((d) => d.second);
    swingSpeed.gp = this.reducer(swingSpeed.dim.group(), (v) => v.swing.speed);

    let hitballSpeed = {};
    hitballSpeed.dim = shot.dimension((d) => d.second);
    hitballSpeed.gp = this.reducer(hitballSpeed.dim.group(), (v) => v.impact.speed);

    this.metricNames = ['showSpinMetric', 'showSwingspMetric', 'showHitballspMetric'];
    for (let value of this.metricNames) {
      // TODO : $watchを$scopeを参照しないように同等な別実装を行う
      $parse(value).assign($scope, true);
      $scope.$watch(value, (on, _) => {
        this.setMetricVisibility(value, on);
      });
    }

    this.userSeriesOptions = {
      height: 78,
      x: d3.time.scale().domain([Date(2015, 7, 1), Date()]),
      dimension: userSeries.dim,
      group: userSeries.gp,
      margins: {left: 48, top: 0, right: 48, bottom: 30},
      elasticY: true,
      elasticX: false,
      brushOn: false, // データが揃ってからtrueにする
      transitionDuration: 500,
      postSetupChart: (chart, options) => {
        let beginDate;
        let endDate;
        beginDate = new Date(this.$sessionStorage[this.Const.SSAPP_LESSON_BEGIN_DATE]);
        endDate = new Date(this.$sessionStorage[this.Const.SSAPP_LESSON_END_DATE]);
        chart.yAxis().ticks(0);
        chart.filter([beginDate, endDate]);
        this.userSeriesChart = this.$rootScope.userSeriesChart = chart;
        this.setResizeHandler(chart, 'userSeries');
        this.sharedState.graphPromise.resolve(chart);
      }
    };

    this.drawFlaf = false;
    let ccCounter = 0;
    this.swingtypeChartOptions = {
      dimension: swingType.dim,
      group: swingType.gp,
      legend: dc.legend().x(180).y(20),
      renderLabel: false,
      ordering: (d) => {
        return this.swingTypes.getOrderIdByLabel(d.key);
      },
      colors: (key) => {
        return this.swingTypes.getColorByLabel(key);
      },
      transitionDuration: 500,
      postSetupChart: (chart) => {
        this.swingtypeChart = this.$rootScope.swingtypeChart = chart;
        let legend = chart.legend();
        legend.horizontal(false);
        chart.on('pretransition', (c) => {
          ccCounter = ccCounter + 1;
          if (ccCounter > 2) {
            this.setRelayoutSwingtypeChart(chart, impactPoint.gp);
          }
        });
        this.setResizeHandler(chart, 'swingtypeChart');
      }
    };

    let img = new Image();
    let imgMask = new Image();
    img.src = './res/st_detail/detail_heatmap_racquet.png';
    imgMask.src = './res/st_detail/detail_heatmap_racquet_mask.png';

    let canvas = document.getElementById('img_cvs');
    let canvasMask = document.getElementById('img_cvs_mask');
    img.onload = function () {
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
    };
    imgMask.onload = function () {
      var ctxMask = canvasMask.getContext('2d');
      ctxMask.drawImage(imgMask, 0, 0);
    };
    let parentContainer = document.getElementById('heatmapContainer');
    this.impactHeatmap = h337.create({
      container: parentContainer,
      width: HEAT_MAP_WIDTH,
      height: HEAT_MAP_HEIGHT,
      maxOpacity: 1,
      minOpacity: 0,
      blur: 0.65,
      gradient: {
        '.4': '#00E',  // Blue
        '.5': '#0EE', // Blue
        '.7': '#0E0', // Green
        '.75': '#EE0', // Yellow
        '.8': '#E00'  // Red
      }
    });

    this.impactPointMapper = this.createMap(HEAT_MAP_WIDTH, HEAT_MAP_HEIGHT);

    this.metricsChartOptions = {
      height: 58.5,
      margins: {left: 40, top: 0, right: 40, bottom: 5},
      brushOn: false,
      transitionDuration: 500,
      renderHorizontalGridLines: true,
      dimension: spin.dim,
      gap: 1,
      x: d3.scale.linear().domain([0, 1000]),
      y: d3.scale.linear().domain([-12, 13]),
      rightY: d3.scale.linear().domain([0, 220]),
      elasticX: true,
      elasticY: false,
      shareTitle: false,
      postSetupChart: (chart, options) => {
        this.metricsChart = chart;
        chart.compose([
          this.buildMetricLineChart(chart, spin.gp, this.backgroundColorByClassName('sss-label-spin')),
          this.buildMetricLineChart(chart, swingSpeed.gp, this.backgroundColorByClassName('sss-label-swingsp'))
            .useRightYAxis(true),
          this.buildMetricLineChart(chart, hitballSpeed.gp, this.backgroundColorByClassName('sss-label-hitballsp'))
            .useRightYAxis(true)
        ]);
        chart.yAxis().ticks(4);
        chart.rightYAxis().ticks(4);
        chart.rightYAxisLabel('km/h', 10);
        this.setResizeHandler(chart, 'metricsChart');
        chart.on('pretransition', (_chart) => {
          // 再描画時に表示/非表示を反映させる
          for (let value of this.metricNames) {
            // TODO : $scopeを参照しないように同等な別実装を行う
            this.setMetricVisibility(value, this.$scope[value]);
          }
        });
      }
    };

    TennisGraph.$inject = [
      '$scope', '$rootScope', '$element',
      '$q', '$http', '$parse', '$sessionStorage',
      'SwingTypeConstants', 'ImpactPointConstants',
      'sssSharedState', 'SharedState', 'Const'
    ];
  }

  showSelectShot () {
    if (this.$sessionStorage[this.Const.SSAPP_RENDER_FIN] === false) {
      return;
    } else {
      // ショット選択ダイアログ
      this.UiSharedState.turnOn('dialogSelectShotPopup');

      /*
        ダイアログが表示されてからチェックするラジオボタンを判断する
      */
      let that = this;
      $(function () {
        let dialogRadioBtn = document.getElementsByName('shotRadio');
        let idx = that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.all ? 0
        : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.foreF ? 1
        : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.foreS ? 2
        : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.backF ? 3
        : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.backS ? 4
        : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.foreV ? 5
        : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.backV ? 6
        : that.$sessionStorage[that.Const.SSAPP_SHOT_KIND] === that.Const.SHOT_TYPE.smash ? 7
        : 8;
        dialogRadioBtn[idx].checked = true;
        that.$rootScope.lessonBeginDate = that.$sessionStorage[that.Const.SSAPP_LESSON_BEGIN_DATE];
        that.$rootScope.lessonEndDate = that.$sessionStorage[that.Const.SSAPP_LESSON_END_DATE];
      });
    }
  }

  backgroundColorByClassName (className) {
    return window
      .getComputedStyle(document.getElementsByClassName(className)[0])
      .getPropertyValue('background-color');
  }

  buildMetricLineChart (chart, gp, color) {
    return dc.lineChart(chart)
      .group(gp)
      .colors(color)
      .keyAccessor((d) => d.value.pos)
      .title((d) => {
        return `${Math.round(d.value.ave)}`;
      })
      .valueAccessor((d) => d.value.ave);
  }

  buildSwingTypeGroup (gp) {
    return {
      all: () => {
        let all = gp.all();
        if (all.length === this.swingTypes.length) {
          return all;
        }
        let map = this.swingTypes.map((d, idx) => {
          for (let i = 0; i < all.length; ++i) {
            if (all[i].key === d.label) {
              return all[i];
            }
          }
          return {key: d.label, value: 0};
        });
        return map;
      }
    };
  }

  setMetricVisibility (metricName, on) {
    if (this.metricsChart) {
      this.metricsChart.selectAll(`.sub._${this.metricNames.indexOf(metricName)} .chart-body`).style('visibility', on ? 'visible' : 'hidden');
    }
  }

  setRelayoutSwingtypeChart (chart, gp) {
    // heatmap refresh
    this.updateImpactpointHeatmap(gp);
    if (this.drawFlaf === false) {
      this.drawFlaf = true;
      chart.width(360).height(162).cx(85).cy(85).radius(70).innerRadius(56);
      chart.redraw();
    }
  }

  setResizeHandler (chart, name, ratio = null, handler = null) {
    let uiState = this.UiSharedState;
    // TODO : $watchを$scopeを参照しないように同等な別実装を行う
    this.$scope.$watch(() => {
      return uiState.get(name);
    }, (newVal) => {
      chart.width(newVal);
      if (ratio) {
        chart.height(newVal * ratio);
      }
      if (handler) {
        handler(chart);
      }
      if (chart.rescale) {
        chart.rescale();
      }
      chart.redraw();
    }, true);
  }
  reducer (group, valueAccessor) {
    // 平均、最大、最小を求めつつReduce
    let gp = group.reduce(
      /* add */ (p, v) => {
        let value = valueAccessor(v);
        p.count++;
        p.objs[v.id] = v;
        p.sum += value;
        p.indexSum += v.index;
        p.ave = p.count ? p.sum / p.count : 0;
        p.indexAve = p.count ? p.indexSum / p.count : p.indexAve;
        if (p.count === 1) {
          p.max = value;
          p.min = value;
        } else {
          p.max = p.max > value ? p.max : value;
          p.min = p.min < value ? p.min : value;
        }
        return p;
      },
      /* remove */ (p, v) => {
        let value = valueAccessor(v);
        p.count--;
        delete p.objs[v.id];
        p.sum -= value;
        p.indexSum -= v.index;
        p.ave = p.count ? p.sum / p.count : 0;
        p.indexAve = p.count ? p.indexSum / p.count : p.indexAve;
        if (p.count === 0) {
          p.max = 0;
          p.min = 0;
        } else if (p.max <= value || p.min >= value) {
          p.max = -Infinity;
          p.min = Infinity;
          Object.keys(p.objs).forEach((id) => {
            let vv = valueAccessor(p.objs[id]);
            p.max = p.max > vv ? p.max : vv;
            p.min = p.min < vv ? p.min : vv;
          });
        }
        return p;
      },
      /* initial */ () => {
        return {
          objs: {},
          count: 0,
          sum: 0,
          max: -Infinity,
          min: Infinity,
          indexSum: 0
        };
      }
    );

    // 空になったグループ(count=0)を、X軸スケールを歪めて非表示にする。
    // 実際には軸のスケールではなくKeyの値を変更する。
    // X軸は常に0~100として、中身のあるグループを等間隔に並べ、
    // 中身のないグループの幅が0になるよう、直前の中身のあるグループと同じ値に調整する。
    // これでフィルタリング時のアニメーションが正しいものになる。
    return {
      all: () => {
        let curr = 0.0;
        let max = gp.all().filter((d) => (d.value.count !== 0)).length;
        let actual = gp.all().filter((d) => (d.value.count !== 0)).length;
        let div = max / actual;
        let firstPosValue = {
          pos: 0,
          ave: 0,
          min: 0,
          max: 0
        };
        let lastValue = {
          pos: 1,
          ave: 0,
          min: 0,
          max: 0
        };
        let result = gp.all().map((d) => {
          let out = {key: d.key, value: d.value};
          if (d.value.count !== 0) {
            curr += div;
            out.value.pos = curr;
            if (out.value.pos === 1) {
              // pos1のvalueを保持
              firstPosValue = out.value;
            }
            lastValue = d.value;
          } else {
            // empty bin uses last value
            out.value = {
              pos: lastValue.pos,
              ave: lastValue.ave,
              min: lastValue.min,
              max: lastValue.max
            };
          }
          return out;
        });
        for (let val of result) {
          // empty bin uses last valueが登録されてしまっているため、
          // 実際にLineChartに表示されているpos1のvalueで更新しておく
          if (val.value.pos === 1) {
            val.value = firstPosValue;
          }
        }
        return result;
      }
    };
  }

  // impact point heatmap を更新する
  updateImpactpointHeatmap (impactPointGroup) {
    let max = 100;
    let min = 0;
    let t = [];
    let ret = impactPointGroup.top(impactPointGroup.size());
    let impactMax = ret.length >= 1 ? ret[0].value : 0;
    for (var i = 0; i < ret.length; ++i) {
      let x = this.impactPointMapper[ret[i].key];
      if (ret[i].value > 0) {
        x.value = this.calHeatMapVal(impactMax, ret[i].value);
        t.push(x);
      } else {
        x.value = 0;
        t.push(x);
      }
    }
    this.impactHeatmap.setData({
      min: min,
      max: max,
      data: t
    });
  }

  // 割合を計算
  calHeatMapVal (max, me) {
    let val = max === 0 || me === 0 ? 0 : (me / max) * 100;
    return (val < 70) ? 50
    : (val < 99) ? 70
    : val;
  }

  // 座標作成
  createMap (width, height) {
    let highRadius = 50;
    let lowRadius = 50;
    let X_SCALE = 0.11;
    let X_OFFSET = 0.2;
    let Y_SCALE = 0.1;
    let Y_OFFSET = 0.1;

    let array = [
      { radius: lowRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: lowRadius },
      { radius: lowRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: lowRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: lowRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: lowRadius },
      { radius: lowRadius },
      { radius: highRadius },
      { radius: highRadius },
      { radius: lowRadius }
    ];

    for (var i = 0; i < array.length; ++i) {
      array[i].x = Math.floor(width * (X_OFFSET + X_SCALE * this.impactPoints[i][0]));
      array[i].y = Math.floor(height * (Y_OFFSET + Y_SCALE * this.impactPoints[i][1]));
      array[i].value = 0;
    }

    return array;
  }

}

angular.module('myApp').component(COMPONENT_NAME,
  {
    bindings: {
      name: '@' + COMPONENT_NAME,
      chartinfo: '=chartinfo'
    },
    controller: TennisGraph,
    templateUrl: 'app/components/lesson-detail/graph.html'
  }
);



// WEBPACK FOOTER //
// ./app/components/lesson-detail/graph.es6